function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createLabel, updateLabel } from '@/api/rsManagement';
import { Debounce } from '@/utils/validate';
export default {
  components: {},
  data: function data() {
    return {
      loading: false,
      visible: false,
      pram: {}
      // pram: {scope: []},
    };
  },
  mounted: function mounted() {},
  methods: {
    openInit: function openInit(tagDetails) {
      var _tagDetails$scope;
      // 确保数据正确初始化，包括首页推荐状态
      this.pram = _objectSpread(_objectSpread({}, tagDetails), {}, {
        scope: tagDetails !== null && tagDetails !== void 0 && tagDetails.scope ? tagDetails === null || tagDetails === void 0 ? void 0 : (_tagDetails$scope = tagDetails.scope) === null || _tagDetails$scope === void 0 ? void 0 : _tagDetails$scope.split(',') : [],
        isHome: (tagDetails === null || tagDetails === void 0 ? void 0 : tagDetails.isHome) || 0,
        // 确保首页推荐状态正确回显
        status: (tagDetails === null || tagDetails === void 0 ? void 0 : tagDetails.status) !== undefined ? tagDetails === null || tagDetails === void 0 ? void 0 : tagDetails.status : 1,
        // 确保状态正确回显
        labelName: (tagDetails === null || tagDetails === void 0 ? void 0 : tagDetails.labelName) || '' // 确保标签名称正确回显
      });
      console.log('编辑组件接收到的数据:', tagDetails);
      console.log('编辑组件初始化后的数据:', this.pram);
      this.visible = true;
    },
    handerSubmit: Debounce(function (form) {
      var _this2 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this2.loading = true;
        var apiCall = _this2.pram.id ? updateLabel : createLabel;
        var data = _objectSpread(_objectSpread({}, _this2.pram), {}, {
          supplierId: _this2.pram.scope && _this2.pram.scope.length > 0 ? parseInt(_this2.pram.scope[0]) : 0,
          isHomepageRecommend: _this2.pram.isHome // 确保首页推荐字段正确传递
        });
        apiCall(data).then(function (response) {
          _this2.$message.success('操作成功');
          _this2.loading = false;
          _this2.visible = false;
          _this2.$emit('doRefresh');
        }).catch(function () {
          _this2.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    //上传图片
    modalPicTap: function modalPicTap(tit, dataIndex) {
      var _this = this;
      this.$modalUpload(function (img) {
        _this.pram[dataIndex] = img[0].sattDir;
      }, tit, 'system');
    }
  }
};